import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import authReducer from './slices/authSlice';
import { localApi } from './api/localApi';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    [localApi.reducerPath]: localApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(localApi.middleware),
});

// Enables refetchOnFocus / refetchOnReconnect for queries that opt in
// (the nav-badge counts). Without this, those options are inert.
setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
